import React,  { useEffect, useRef } from "react";
import { css } from "@emotion/react";
import { gsap } from "gsap/all";

const Logo = (props) => {
  const logoRef = useRef(null);
  useEffect(() => {
    gsap.to(logoRef.current, {
      opacity: 1,
      duration: 0.5
    });
  }, []);

  return (
    <div ref={logoRef} css={css`
      align-items: center;
      bottom: 28%;
      display: flex;
      height: unset;
      justify-content: center;
      left: 0;
      margin: auto;
      position: absolute;
      right: 0;
      top: 28%;
      width: unset;
      opacity: 0;
    `}>
      <svg width={72} height={72} viewBox="0 0 72 72" {...props}>
        <path
          fill="black"
          d="M16 22.461V50.21h5.841V37.988h6.572v12.221h5.842V22.461h-5.842v10.992h-6.572V22.46H16zm40.211 6.918c0-2.537-.307-7.379-8.032-7.379-5.38 0-9.185 2.267-9.185 7.379 0 4.112 1.653 5.842 5.227 8.032l3.459 2.114c1.575.96 3.035 1.653 3.035 3.92 0 1.96-1.114 3.075-3.074 3.075-2.344 0-3.151-1.384-3.151-4.15v-.731h-5.88v1.73c0 3.612 1.614 7.34 8.416 7.34 6.456 0 9.531-2.652 9.531-7.994 0-3.036-.846-4.88-4.266-7.033l-5.61-3.574c-1.23-.769-1.768-1.807-1.768-2.96 0-1.844 1.114-3.074 2.805-3.074 1.845 0 2.805 1.23 2.805 3.612v.654h5.688v-.961z"
        />
      </svg>
      <span css={css`
        width: 84px;
        height: 84px;
        border-radius: 50%;
        position: absolute;
        animation: rotate 1s linear infinite;
      &::before {
        content: "";
        box-sizing: border-box;
        position: absolute;
        inset: 0px;
        border-radius: 50%;
        border: 5px solid black;
        animation: dash 2s linear infinite ;
      }

      @keyframes rotate {
        100%   {transform: rotate(360deg)}
      }

      @keyframes dash {
        0%, 100%   {clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}
        25%, 75%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}
        50%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}
      }
      `}></span>
    </div>
  );
}

export default Logo;



